import { Link } from 'react-router-dom';
import { admin } from '../../lib/api';
import { useApi } from '../../hooks/useApi';
import { useAdminT } from './adminI18n';

export default function AdminOverviewPage() {
  const t = useAdminT();
  const stats = useApi(() => admin.stats(), []);
  const reviewQ = useApi(() => admin.reviewQueue(undefined, 100), []);
  const proposalQ = useApi(() => admin.proposalQueue(undefined, 100), []);

  const s = stats.status === 'success' ? stats.data : null;
  const reviewN = reviewQ.status === 'success' ? reviewQ.data.length : null;
  const proposalN = proposalQ.status === 'success' ? proposalQ.data.length : null;

  const cards = [
    { key: 'review', label: t('stat.reviewPending'), value: reviewN, to: '/admin/review', accent: true },
    { key: 'proposal', label: t('stat.proposalPending'), value: proposalN, to: '/admin/proposals', accent: true },
    { key: 'library', label: t('stat.libraryBooks'), value: s?.library_books ?? null, to: '/admin/curation' },
    { key: 'paid', label: t('stat.paidUploads'), value: s?.paid_uploads ?? null, to: null },
    { key: 'uploads', label: t('stat.userUploads'), value: s?.user_uploads ?? null, to: null },
  ];

  return (
    <div className="admin-page">
      <header className="admin-page__head">
        <h1>{t('overview.title')}</h1>
        <p className="admin-page__sub">{t('overview.subtitle')}</p>
      </header>

      <div className="admin-stats">
        {cards.map((c) => {
          const body = (
            <>
              <span className="admin-stat__label">{c.label}</span>
              <span className="admin-stat__value">{c.value == null ? '—' : c.value}</span>
            </>
          );
          return c.to ? (
            <Link key={c.key} to={c.to} className={`admin-stat${c.accent ? ' is-accent' : ''} is-link`}>
              {body}
            </Link>
          ) : (
            <div key={c.key} className="admin-stat">{body}</div>
          );
        })}
      </div>

      {reviewN === 0 && proposalN === 0 && (
        <p className="admin-allclear">✦ {t('allClear')}</p>
      )}
    </div>
  );
}
